<div class="bazis-card-value__value">
    <slot name="value"></slot>
</div>
<div class="bazis-card-value__title">
    <slot name="title"></slot>
</div>
